// src/kiosk.js
export function applyKioskRestrictions() {
  // Disable context menu
  window.addEventListener('contextmenu', e => e.preventDefault(), { passive: false });

  // Disable drag & drop
  ['dragstart', 'drop'].forEach(event => {
    window.addEventListener(event, e => e.preventDefault(), { passive: false });
  });

  // Disable common dev shortcuts
  document.addEventListener('keydown', e => {
    const key = (e.key || '').toLowerCase();
    const isF12 = e.key === 'F12';
    const isCtrlShiftI = e.ctrlKey && e.shiftKey && key === 'i';
    const isReload = (e.ctrlKey && key === 'r') || (e.metaKey && key === 'r');

    if (isF12 || isCtrlShiftI || isReload) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  /**
   * Kiosk: prevent soft keyboard only when user taps/clicks NON-interactive areas.
   * The old version blurred on every click and broke all textboxes.
   */
  const shouldKeepFocus = (target) => {
    if (!(target instanceof Element)) return false;

    // Any obvious interactive/control element
    if (
      target.closest(
        [
          'input',
          'textarea',
          'select',
          '[contenteditable="true"]',
          'button',
          'a',
          '[role="button"]',
          '[role="textbox"]',
          '[role="combobox"]',
          '[role="listbox"]',
          '.v-input',
          '.v-text-field',
          '.v-textarea',
          '.v-select',
          '.v-autocomplete',
          '.v-combobox',
          '.v-menu__content',
          '.v-dialog',
          '.v-overlay__content',
          '.v-date-picker-table',
        ].join(',')
      )
    ) {
      return true;
    }

    return false;
  };

  window.addEventListener(
    'click',
    (e) => {
      // If the click is on/inside something interactive, do NOT blur.
      if (shouldKeepFocus(e.target)) return;

      // Otherwise, blur (prevents soft keyboard if focus was on an input)
      const ae = document.activeElement;
      if (ae && typeof ae.blur === 'function') ae.blur();
    },
    true // capture: run before other handlers; consistent behavior
  );
}
